module.exports = __webpack_public_path__ + "img/sample-report-07@3x.634ba48a.png";